module.exports = __webpack_public_path__ + "img/boiler-E-fire.81d8defb.png";